module.exports = __webpack_public_path__ + "img/emarat.78a052e8.svg";